import "./styles.scss";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import useResponsive from "libs/helpers/useResponsive";
import usePagination from "libs/helpers/usePagination";
import priceRender from "libs/helpers/priceRender";

import Loader from "components/Loader";
import Pagination from "components/Pagination";
import ScrollTopMobile from "components/ScrollTopMobile";

import { ReactComponent as ViewIcon } from "assets/icons/new/view.svg";
import { ReactComponent as NoDataIcon } from "assets/icons/no-data.svg";

const walletValue = (wallet) => {
  const items = (wallet || []).filter((item) => item?.amount);

  if (!items.length) return "0";

  return items
    .map(({ amount, currency }) =>
      priceRender(((amount || 0) / 100).toFixed(2), currency),
    )
    .join(", ");
};

const mainClass = "referral-programs-tiles";

const ReferralProgramsTiles = ({ data, loading }) => {
  const { t } = useTranslation();
  const { max } = useResponsive();
  const navigate = useNavigate();
  const { search } = useLocation();
  const perPage = max.sm ? 4 : 12;
  const { currentPage, totalPages, handlePageChange, paginatedData } =
    usePagination(data, perPage);

  return (
    <div className={mainClass}>
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          key={currentPage}
          className={`${mainClass}__row`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ type: "tween", duration: 0.3 }}
        >
          {loading ? (
            <div className={`${mainClass}__loader`}>
              <Loader color="blue" center size="large" />
            </div>
          ) : paginatedData.length > 0 ? (
            paginatedData.map(
              ({ id, first_name, last_name, email, leads, wallet }) => {
                return (
                  <div className={`${mainClass}__tile`} key={id}>
                    <h4>{`${first_name} ${last_name}`}</h4>
                    <div className={`${mainClass}__tile-summary`}>
                      <span>{t("Email")}</span>
                      <strong>{email}</strong>
                    </div>
                    <div className={`${mainClass}__tile-summary`}>
                      <span>{t("Leads")}</span>
                      <strong>{leads}</strong>
                    </div>
                    <div className={`${mainClass}__tile-summary`}>
                      <span>{t("Wallet")}</span>
                      <strong>{walletValue(wallet)}</strong>
                    </div>
                    <button
                      type="button"
                      className={`${mainClass}__tile-action`}
                      onClick={() =>
                        navigate(`/referral-program/${id}${search}`)
                      }
                    >
                      {t("View details")}
                      <ViewIcon aria-hidden="true" />
                    </button>
                  </div>
                );
              },
            )
          ) : (
            <div className={`${mainClass}__no-data`}>
              <NoDataIcon aria-hidden="true" />
              <p>{t("No data")}</p>
            </div>
          )}
        </motion.div>
      </AnimatePresence>
      {totalPages > 1 && !loading && (
        <div className={`${mainClass}__pagination`}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={handlePageChange}
          />
        </div>
      )}
      <div className={`${mainClass}__scroll`}>
        <ScrollTopMobile />
      </div>
    </div>
  );
};

export default ReferralProgramsTiles;